import { useEffect, useState } from 'react';

const useBodyScrollHandler = () => {
  const [startY, setStartY] = useState(0);
  const [startTime, setStartTime] = useState(0);
  const [bodyScroll, setBodyScroll] = useState(false);

  useEffect(() => {
    const handleTouchStart = event => {
      setStartY(event.touches[0].clientY);
      setStartTime(Date.now());
    };

    const handleTouchMove = event => {
      const currentY = event.touches[0].clientY;
      const duration = Date.now() - startTime;
      const isScrollingDown = currentY < startY;
      if (isScrollingDown && duration >= 100) setBodyScroll(true);
      else if (!isScrollingDown && duration >= 200) setBodyScroll(false);

      setStartY(currentY);
    };

    window.addEventListener('touchstart', handleTouchStart, { passive: true });
    window.addEventListener('touchmove', handleTouchMove, { passive: true });

    return () => {
      window.removeEventListener('touchstart', handleTouchStart);
      window.removeEventListener('touchmove', handleTouchMove);
    };
  }, [bodyScroll, startTime, startY]);

  return { bodyScroll };
};

export default useBodyScrollHandler;
